import { post } from '../api/client';
import { QuoteRequest, QuoteResponse, RegOnlyResponse } from '../../models/services/api/postQuote';
import { log } from '@domgen/shared/utils/log';

export const postQuote = async (
  quoteRequest: QuoteRequest,
): Promise<{ statusCode: number; data: QuoteResponse | RegOnlyResponse }> => {
  try {
    const res = await post<QuoteResponse | RegOnlyResponse>('/v2/quote', quoteRequest);
    if (res.statusCode !== 200 && res.statusCode !== 201) {
      log.error({
        message: 'Failed to fetch quote',
        data: { statusCode: res.statusCode, response: res.data },
      });
      throw new Error(`Failed to fetch quote, status code: ${res.statusCode}`);
    }
    return res;
  } catch (err) {
    log.error({ message: 'Fetch error', data: err });
    throw err;
  }
};
